// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"8vG9P":[function(require,module,exports,__globalThis) {
/**
 * Created By Hensi Murcia
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _auth = require("firebase/auth");
var _app = require("firebase/compat/app");
var _appDefault = parcelHelpers.interopDefault(_app);
var _auth1 = require("firebase/compat/auth");
var _common = require("./common");
"use strict";
//Initialize elements
var btnLogin = document.getElementById("btnLogin");
var etEmail = document.getElementById("etEmail");
var etPassword = document.getElementById("etPassword");
var loader = document.getElementById("loading");
var btnPhoneLogin = document.getElementById("btnPhoneLogin");
var btnEmailLogin = document.getElementById("btnEmailLogin");
var divEmailOptions = document.getElementById("emailOptions");
var divPhoneOptions = document.getElementById("phoneOptions");
var ui = new firebaseui.auth.AuthUI((0, _appDefault.default).auth());
var trans;
$(document).ready(function() {
    $(function() {
        translatePage();
        initClickListeners();
        initFirebaseUi();
        window.onclick = function(event) {
            if (!event.target.matches(".dropbtn")) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for(i = 0; i < dropdowns.length; i++){
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains("show")) openDropdown.classList.remove("show");
                }
            }
        };
        btnLogin.addEventListener("click", login);
        etPassword.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                //"Enter" key on keyboard
                //cancel the deafult button if needed
                event.preventDefault();
                btnLogin.click();
            }
        });
        btnNext.addEventListener("click", function() {
            checkEmail(etEmail.value);
        });
        etEmail.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                //cancel the deafult button if needed
                event.preventDefault();
                btnNext.click();
                etPassword.focus();
            }
        });
        btnRegister.addEventListener("click", function() {
            var email = etEmail.value.trim();
            var pass = etPassword.value.trim();
            if (pass && email) {
                (0, _common.setDisplay)(loading, "block");
                (0, _appDefault.default).auth().createUserWithEmailAndPassword(email, pass).then(function(user) {
                    if (user) (0, _common.setDisplay)(loading, "none");
                    else {
                        (0, _common.showToast)(trans.errorRegister);
                        (0, _common.setDisplay)(loading, "none");
                    }
                }).catch(function(error) {
                    // Handle Errors here.
                    var errorMessage = error.message;
                    (0, _common.showToast)(errorMessage);
                    (0, _common.setDisplay)(loading, "none");
                });
            }
        });
        btnEmailLogin.addEventListener("click", function() {
            (0, _common.setDisplay)(divEmailOptions, "block");
            (0, _common.setDisplay)(divPhoneOptions, "none");
        }, false);
        btnPhoneLogin.addEventListener("click", function() {
            (0, _common.setDisplay)(divEmailOptions, "none");
            (0, _common.setDisplay)(divPhoneOptions, "block");
        }, false);
    });
});
function initClickListeners() {
    btnTranslate.addEventListener("click", function() {
        showDropdown();
    });
    aEn.addEventListener("click", function() {
        translatePage("en");
    });
    aEs.addEventListener("click", function() {
        translatePage("es");
    });
    myModal.querySelector(".close").addEventListener("click", function() {
        (0, _common.closeMyModal)();
    });
    myModal.querySelector(".btnBlue").addEventListener("click", function() {
        (0, _common.closeMyModal)();
    });
}
function showDropdown() {
    document.getElementById("langDropdown").classList.toggle("show");
}
/**
 * Init Firebase phone ui
 */ function initFirebaseUi() {
    ui.start(divPhoneOptions, {
        signInOptions: [
            {
                provider: (0, _appDefault.default).auth.PhoneAuthProvider.PROVIDER_ID,
                recaptchaParameters: {
                    type: "image",
                    size: "normal",
                    badge: "bottomleft"
                }
            }
        ]
    });
}
/**
 * check if user logged in
 */ (0, _appDefault.default).auth().onAuthStateChanged(function(user) {
    if (user) {
        // User is signed in.
        toggleLoader(true);
        if (window.location.search.includes("action=manage")) window.location.replace("../removeAccount.html?action=success");
        else window.location.replace("../chat.html");
    }
});
/**
 * function login()
 * logs in user to firebase
 */ function login() {
    toggleLoader(false);
    var email = etEmail.value;
    var password = etPassword.value;
    if (!document.getElementById("cbRememberMe").checked) (0, _appDefault.default).auth().setPersistence((0, _appDefault.default).auth.Auth.Persistence.SESSION).then(function() {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        return (0, _appDefault.default).auth().signInWithEmailAndPassword(email, password);
    }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        toggleLoader(true);
        (0, _common.setModalMessage)("Error " + errorCode + ": " + errorMessage);
        (0, _common.openCommonModal)();
    });
    else (0, _appDefault.default).auth().signInWithEmailAndPassword(email, password).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        toggleLoader(true);
        (0, _common.setModalMessage)("Error " + errorCode + ": " + errorMessage);
        (0, _common.openCommonModal)();
    //window.alert('Error ' + errorCode + ": " + errorMessage);
    });
}
function toggleLoader(hide) {
    if (hide) loader.style.display = "none";
    else loader.style.display = "block";
}
function checkEmail(email) {
    (0, _appDefault.default).auth().fetchSignInMethodsForEmail(email).then(function(signInMethods) {
        (0, _common.setDisplay)(btnNext, "none");
        (0, _common.setDisplay)(etPassword, "block");
        if (signInMethods.indexOf((0, _appDefault.default).auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) != -1) {
            (0, _common.setDisplay)(divPassInfo, "block");
            divPassInfo.textContent = trans.welcomeBack;
            etPassword.placeholder = trans.password;
            (0, _common.setDisplay)(btnLogin, "block");
            (0, _common.setDisplay)(btnRegister, "none");
            var checkMark = emailOptions.querySelector(".check");
            (0, _common.setDisplay)(checkMark, "block");
        // User can sign in with email/password.
        } else {
            (0, _common.setDisplay)(divPassInfo, "block");
            divPassInfo.textContent = trans.createPass;
            etPassword.placeholder = trans.anyPass;
            (0, _common.setDisplay)(btnLogin, "none");
            (0, _common.setDisplay)(btnRegister, "block");
            var checkMark = emailOptions.querySelector(".check");
            (0, _common.setDisplay)(checkMark, "none");
        }
        (0, _common.setDisplay)(loading, "none");
        etPassword.focus();
    }).catch(function(error) {
        (0, _common.showToast)(error);
        (0, _common.setDisplay)(loading, "none");
    // Some error occurred, you can inspect the code: error.code
    });
}
var language = {
    eng: {
        welcome: "Welcome",
        messageLogout: "Are you sure you want to logout?",
        initSession: "Login using the easiest option for you",
        phone: "Phone",
        email: "email",
        password: "Password",
        remember: "Remember me",
        login: "Login",
        disclaimer: 'By continuing, you agree to our <a href="about.html#terms">Terms and Conditions</a>, and <a href="about.html">Privacy policy</a>',
        welcomeBack: "Welcome back! Enter the password for this account",
        anyPass: "Enter any password",
        idiom: "En"
    },
    es: {
        welcome: "Bienvenid@",
        messageLogout: "\xbfEst\xe1s segur@ de que quieres cerrar sesi\xf3n?",
        initSession: "Inicia sesi\xf3n con la opci\xf3n m\xe1s f\xe1cil para ti",
        phone: "Tel\xe9fono",
        email: "Correo electr\xf3nico",
        password: "Contrase\xf1a",
        remember: "Recu\xe9rdame",
        login: "Iniciar sesi\xf3n",
        disclaimer: 'Al continuar, aceptas nuestros <a href="about.html#terms">T\xe9rminos y Condiciones</a>, y <a href="about.html">Pol\xedtica de Seguridad</a>',
        welcomeBack: "\xa1Bienvenido de nuevo! Ingrese la contrase\xf1a para esta cuenta",
        anyPass: "Cualquier contrase\xf1a",
        idiom: "Es"
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        if (lang.includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            aEn.className = aEn.className.replace(" set", "");
            aEs.className += " set";
            (0, _common.setCookie)("lang", "es", 365);
        } else {
            trans = language.eng;
            document.getElementsByTagName("html")[0].setAttribute("lang", "en");
            aEs.className = aEn.className.replace(" set", "");
            aEn.className += " set";
            (0, _common.setCookie)("lang", "en", 365);
        }
        translate = true;
    } else if ((0, _common.getCookie)("lang") != "") {
        if ((0, _common.getCookie)("lang").includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            translate = true;
            (0, _common.setCookie)("lang", "es", 365);
        } else trans = language.eng;
    } else if (navigator.language && navigator.language.includes("es")) {
        trans = language.es;
        document.getElementsByTagName("html")[0].setAttribute("lang", "es");
        translate = true;
        aEn.className = aEn.className.replace(" set", "");
        aEs.className += " set";
    } else trans = language.eng;
    if (translate) {
        menuLang.textContent = trans.idiom;
        modalMessage.textContent = trans.messageLogout;
        loginInst.textContent = trans.initSession;
        btnPhoneLogin.textContent = trans.phone;
        btnEmailLogin.textContent = trans.email;
        etEmail.placeholder = trans.email;
        etPassword.placeholder = trans.password;
        emailOptions.querySelector("label").textContent = trans.remember;
        btnLogin.textContent = trans.login;
        emailOptions.querySelector("p").innerHTML = trans.disclaimer;
    }
}

},{"firebase/auth":"dZ6yw","firebase/compat/app":"bAwIZ","firebase/compat/auth":"hOIAn","./common":"jYzpo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dZ6yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("@firebase/auth");
parcelHelpers.exportAll(_auth, exports);

},{"@firebase/auth":"fIGSE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fIGSE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionCodeOperation", ()=>(0, _indexD90D2Ee5Js.A));
parcelHelpers.export(exports, "ActionCodeURL", ()=>(0, _indexD90D2Ee5Js.aj));
parcelHelpers.export(exports, "AuthCredential", ()=>(0, _indexD90D2Ee5Js.M));
parcelHelpers.export(exports, "AuthErrorCodes", ()=>(0, _indexD90D2Ee5Js.J));
parcelHelpers.export(exports, "EmailAuthCredential", ()=>(0, _indexD90D2Ee5Js.N));
parcelHelpers.export(exports, "EmailAuthProvider", ()=>(0, _indexD90D2Ee5Js.W));
parcelHelpers.export(exports, "FacebookAuthProvider", ()=>(0, _indexD90D2Ee5Js.X));
parcelHelpers.export(exports, "FactorId", ()=>(0, _indexD90D2Ee5Js.F));
parcelHelpers.export(exports, "GithubAuthProvider", ()=>(0, _indexD90D2Ee5Js.Z));
parcelHelpers.export(exports, "GoogleAuthProvider", ()=>(0, _indexD90D2Ee5Js.Y));
parcelHelpers.export(exports, "OAuthCredential", ()=>(0, _indexD90D2Ee5Js.Q));
parcelHelpers.export(exports, "OAuthProvider", ()=>(0, _indexD90D2Ee5Js._));
parcelHelpers.export(exports, "OperationType", ()=>(0, _indexD90D2Ee5Js.O));
parcelHelpers.export(exports, "PhoneAuthCredential", ()=>(0, _indexD90D2Ee5Js.U));
parcelHelpers.export(exports, "PhoneAuthProvider", ()=>(0, _indexD90D2Ee5Js.P));
parcelHelpers.export(exports, "PhoneMultiFactorGenerator", ()=>(0, _indexD90D2Ee5Js.n));
parcelHelpers.export(exports, "ProviderId", ()=>(0, _indexD90D2Ee5Js.q));
parcelHelpers.export(exports, "RecaptchaVerifier", ()=>(0, _indexD90D2Ee5Js.R));
parcelHelpers.export(exports, "SAMLAuthProvider", ()=>(0, _indexD90D2Ee5Js.$));
parcelHelpers.export(exports, "SignInMethod", ()=>(0, _indexD90D2Ee5Js.S));
parcelHelpers.export(exports, "TotpMultiFactorGenerator", ()=>(0, _indexD90D2Ee5Js.T));
parcelHelpers.export(exports, "TotpSecret", ()=>(0, _indexD90D2Ee5Js.o));
parcelHelpers.export(exports, "TwitterAuthProvider", ()=>(0, _indexD90D2Ee5Js.a0));
parcelHelpers.export(exports, "applyActionCode", ()=>(0, _indexD90D2Ee5Js.a8));
parcelHelpers.export(exports, "beforeAuthStateChanged", ()=>(0, _indexD90D2Ee5Js.y));
parcelHelpers.export(exports, "browserCookiePersistence", ()=>(0, _indexD90D2Ee5Js.a));
parcelHelpers.export(exports, "browserLocalPersistence", ()=>(0, _indexD90D2Ee5Js.b));
parcelHelpers.export(exports, "browserPopupRedirectResolver", ()=>(0, _indexD90D2Ee5Js.m));
parcelHelpers.export(exports, "browserSessionPersistence", ()=>(0, _indexD90D2Ee5Js.c));
parcelHelpers.export(exports, "checkActionCode", ()=>(0, _indexD90D2Ee5Js.a9));
parcelHelpers.export(exports, "confirmPasswordReset", ()=>(0, _indexD90D2Ee5Js.a7));
parcelHelpers.export(exports, "connectAuthEmulator", ()=>(0, _indexD90D2Ee5Js.L));
parcelHelpers.export(exports, "createUserWithEmailAndPassword", ()=>(0, _indexD90D2Ee5Js.ab));
parcelHelpers.export(exports, "debugErrorMap", ()=>(0, _indexD90D2Ee5Js.H));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _indexD90D2Ee5Js.G));
parcelHelpers.export(exports, "fetchSignInMethodsForEmail", ()=>(0, _indexD90D2Ee5Js.ag));
parcelHelpers.export(exports, "getAdditionalUserInfo", ()=>(0, _indexD90D2Ee5Js.ar));
parcelHelpers.export(exports, "getAuth", ()=>(0, _indexD90D2Ee5Js.p));
parcelHelpers.export(exports, "getIdToken", ()=>(0, _indexD90D2Ee5Js.ao));
parcelHelpers.export(exports, "getIdTokenResult", ()=>(0, _indexD90D2Ee5Js.ap));
parcelHelpers.export(exports, "getMultiFactorResolver", ()=>(0, _indexD90D2Ee5Js.at));
parcelHelpers.export(exports, "getRedirectResult", ()=>(0, _indexD90D2Ee5Js.k));
parcelHelpers.export(exports, "inMemoryPersistence", ()=>(0, _indexD90D2Ee5Js.V));
parcelHelpers.export(exports, "indexedDBLocalPersistence", ()=>(0, _indexD90D2Ee5Js.i));
parcelHelpers.export(exports, "initializeAuth", ()=>(0, _indexD90D2Ee5Js.K));
parcelHelpers.export(exports, "initializeRecaptchaConfig", ()=>(0, _indexD90D2Ee5Js.v));
parcelHelpers.export(exports, "isSignInWithEmailLink", ()=>(0, _indexD90D2Ee5Js.ae));
parcelHelpers.export(exports, "linkWithCredential", ()=>(0, _indexD90D2Ee5Js.a3));
parcelHelpers.export(exports, "linkWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.l));
parcelHelpers.export(exports, "linkWithPopup", ()=>(0, _indexD90D2Ee5Js.e));
parcelHelpers.export(exports, "linkWithRedirect", ()=>(0, _indexD90D2Ee5Js.h));
parcelHelpers.export(exports, "multiFactor", ()=>(0, _indexD90D2Ee5Js.au));
parcelHelpers.export(exports, "onAuthStateChanged", ()=>(0, _indexD90D2Ee5Js.z));
parcelHelpers.export(exports, "onIdTokenChanged", ()=>(0, _indexD90D2Ee5Js.x));
parcelHelpers.export(exports, "parseActionCodeURL", ()=>(0, _indexD90D2Ee5Js.ak));
parcelHelpers.export(exports, "prodErrorMap", ()=>(0, _indexD90D2Ee5Js.I));
parcelHelpers.export(exports, "reauthenticateWithCredential", ()=>(0, _indexD90D2Ee5Js.a4));
parcelHelpers.export(exports, "reauthenticateWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.r));
parcelHelpers.export(exports, "reauthenticateWithPopup", ()=>(0, _indexD90D2Ee5Js.f));
parcelHelpers.export(exports, "reauthenticateWithRedirect", ()=>(0, _indexD90D2Ee5Js.j));
parcelHelpers.export(exports, "reload", ()=>(0, _indexD90D2Ee5Js.as));
parcelHelpers.export(exports, "revokeAccessToken", ()=>(0, _indexD90D2Ee5Js.E));
parcelHelpers.export(exports, "sendEmailVerification", ()=>(0, _indexD90D2Ee5Js.ah));
parcelHelpers.export(exports, "sendPasswordResetEmail", ()=>(0, _indexD90D2Ee5Js.a6));
parcelHelpers.export(exports, "sendSignInLinkToEmail", ()=>(0, _indexD90D2Ee5Js.ad));
parcelHelpers.export(exports, "setPersistence", ()=>(0, _indexD90D2Ee5Js.t));
parcelHelpers.export(exports, "signInAnonymously", ()=>(0, _indexD90D2Ee5Js.a1));
parcelHelpers.export(exports, "signInWithCredential", ()=>(0, _indexD90D2Ee5Js.a2));
parcelHelpers.export(exports, "signInWithCustomToken", ()=>(0, _indexD90D2Ee5Js.a5));
parcelHelpers.export(exports, "signInWithEmailAndPassword", ()=>(0, _indexD90D2Ee5Js.ac));
parcelHelpers.export(exports, "signInWithEmailLink", ()=>(0, _indexD90D2Ee5Js.af));
parcelHelpers.export(exports, "signInWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.s));
parcelHelpers.export(exports, "signInWithPopup", ()=>(0, _indexD90D2Ee5Js.d));
parcelHelpers.export(exports, "signInWithRedirect", ()=>(0, _indexD90D2Ee5Js.g));
parcelHelpers.export(exports, "signOut", ()=>(0, _indexD90D2Ee5Js.D));
parcelHelpers.export(exports, "unlink", ()=>(0, _indexD90D2Ee5Js.aq));
parcelHelpers.export(exports, "updateCurrentUser", ()=>(0, _indexD90D2Ee5Js.C));
parcelHelpers.export(exports, "updateEmail", ()=>(0, _indexD90D2Ee5Js.am));
parcelHelpers.export(exports, "updatePassword", ()=>(0, _indexD90D2Ee5Js.an));
parcelHelpers.export(exports, "updatePhoneNumber", ()=>(0, _indexD90D2Ee5Js.u));
parcelHelpers.export(exports, "updateProfile", ()=>(0, _indexD90D2Ee5Js.al));
parcelHelpers.export(exports, "useDeviceLanguage", ()=>(0, _indexD90D2Ee5Js.B));
parcelHelpers.export(exports, "validatePassword", ()=>(0, _indexD90D2Ee5Js.w));
parcelHelpers.export(exports, "verifyBeforeUpdateEmail", ()=>(0, _indexD90D2Ee5Js.ai));
parcelHelpers.export(exports, "verifyPasswordResetCode", ()=>(0, _indexD90D2Ee5Js.aa));
var _indexD90D2Ee5Js = require("./index-d90d2ee5.js");
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _component = require("@firebase/component");

},{"./index-d90d2ee5.js":"844GM","@firebase/app":"iO7sa","@firebase/util":"fHqXn","@firebase/logger":"kY52V","@firebase/component":"6VF6E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["8vG9P"], "8vG9P", "parcelRequire460e", {})

//# sourceMappingURL=login.4c640976.js.map
